import { IItemsUpdateAction, ItemsActionType } from ".";
import { IResult } from "../../data/data";
import { ActionCreator, Action } from "redux";
import { IContentBySearchState, StatusType } from "..";
import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { ItemsUpdatedAction } from "./ItemsUpdatedAction";
import { StatusChangedAction } from "./StatusChangedAction";

/**
 * User initiates a search
 * 
 * note: ThunkAction type parameters:
 * R = Return Type of the inner function
 * S = State (from getState())
 * E = Extra parameter
 * A = Action
 * 
 * @param items
 */

export const ItemsUpdatedThunk: ActionCreator<ThunkAction<void, IContentBySearchState, void, Action>> = (items: IResult[]) => {
    return (dispatch: ThunkDispatch<IContentBySearchState, void, Action>, getState: () => IContentBySearchState): void => {
        if(items.length == 0) {
            dispatch(StatusChangedAction({type: StatusType.NORESULTS, statusMessage: "No results"}));
        }
        else {
            dispatch(StatusChangedAction({type: StatusType.READY}));
        }
        dispatch(ItemsUpdatedAction(items));
    }
}